import { render, staticRenderFns } from "./count.vue?vue&type=template&id=164c5a82&scoped=true"
import script from "./count.vue?vue&type=script&lang=js"
export * from "./count.vue?vue&type=script&lang=js"
import style0 from "./count.vue?vue&type=style&index=0&id=164c5a82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164c5a82",
  null
  
)

export default component.exports